export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getAssessmentApprovalHistoryListlAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_LIST"] = "setAssessmentApprovalHistoryListMutation";
    Mutations["SET_LIST_LOADING"] = "setAssessmentApprovalHistoryListLoadingMutation";
    Mutations["SET_LIST_PAGINATION"] = "setAssessmentApprovalHistoryListPaginationMutation";
})(Mutations || (Mutations = {}));
